export default __webpack_public_path__ + "static/underline-after-50209bca9ca1c4a30e9fd70e88a50fa9d93603390455016e7e4f6db023b7b813.png";